import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';
import Navigation from './Navigation';
import '../styles/Layout.css';

const Layout = () => {
  const { isAuthenticated, loading } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="dashboard-container">
      <Header onMenuToggle={toggleMenu} menuOpen={menuOpen} />
      <Navigation isOpen={menuOpen} onClose={closeMenu} />
      <div className={`nav-overlay ${menuOpen ? 'visible' : ''}`} onClick={closeMenu}></div>
      <main className="page-main">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;

